import { useLocation } from 'react-router-dom';

export const useDashboardFirstMetaSiteId = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const dashboardFirstMetaSiteId = searchParams.get('dashboardFirstMetaSiteId');

  return dashboardFirstMetaSiteId;
};
